import React from "react";
import { Card } from "@components/_Revamp/StyledComponent";
import sinpassLogo from "@assets/images/singpass-logo.svg";
import { css } from "@linaria/core";
import { themeDefault } from "src/theme-revamp";
import { styled } from "@linaria/react";
import SingPassPermissionButton from "@assets/icon/singpass-permission-button.svg";
import { Link, useHistory } from "react-router-dom";
import { ROUTE_PATH } from "@static/route-paths";
import { useAvivaSelector } from "@redux/hook";

const cardStyle = css`
  margin-top: 24px;
  font-weight: 500;
  font-size: 12px;
  line-height: 140%;
  letter-spacing: 0.04em;
  color: #434343;
  max-width: 664px;
  width: 100%;
`;

const AnchorTag = styled.a`
  color: #883E89;
  font-weight: 600;
`;

const CustomButton = styled.button<{ background: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 664px;
  height: 52px;
  margin-top: 24px;
  background: ${(props) => props.background};
  border-radius: 24px;
  border: none;
  width: 100%;
  height: 52px;
  cursor: pointer;
`;

const PermissionButton = css`
  max-width: 285px;
  width: 100%;
  @media screen and (max-width: 768px) {
  }
  @media screen and (max-width: 588px) {
    width: 80%;
  }
`;

const backButton = css`
  border: 1px solid #883E89;
  color: #883E89;
  font-weight: 600;
`;

const infoMsgCard = css`
  color: #c50000;
  gap: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  position: relative;
  line-height: 140%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  border-radius: 16px;
  p {
    margin-left: 12px;
    flex-grow: 2;
  }
  div {
    display: flex;
    justify-content: start;
  }
  a {
    color: #c50000;
  }
  div:nth-child(3) {
    diplay: flex;
    cursor: pointer;

    justify-content: end;
  }
  &:before {
    position: absolute;
    left: 0px;

    content: "";
    background: #c50000;
    width: 8px;
    height: 80px;
  }

  @media screen and (max-width: 767px) {
    max-width: unset;
    border-radius: 0;
    order: -1;
    padding-left: 13px;
    margin-top: -59px;
    margin-bottom: 24px;
    p {
      max-width: 80%;

      flex-grow: 2;
    }
    div:nth-child(3) {
      flex-grow: 1;
      cursor: pointer;
    }
    &:before {
      content: "";
      position: absolute;
      left: 0px;
      background: #c50000;
      width: 8px;
      height: 110px;
    }
  }
`;

const contentLogin = css`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  text-align: center;
  line-height: 140%;
  margin-top: 24px;
  max-width: 400px;
  color: #8a8988;
`;

interface Props {
  onClickRetrieveSingpass: Function;
  toggleAddInfoForm: Function;
  setIsGenericError: Function;
  isGenericError: boolean;
}

function SingpassPermission(props: Props) {
  const {
    onClickRetrieveSingpass,
    toggleAddInfoForm,
    isGenericError,
    setIsGenericError,
  } = props;

  const isShowAddMyInfo = useAvivaSelector(
    (state) => state.loading.isShowAddMyInfo
  );
  const gioDeclaration = useAvivaSelector(state => state.mltcR3Step2.gioDeclaration);
  const history = useHistory();

  function goBack() {
    if(gioDeclaration === "GIO"){
      history.push('/mltc/choose-plan');
    }else{      
     history.replace(ROUTE_PATH.MLTC_HEALTH);
    }    
  }

  return (
    <>
      {isGenericError && (
        <Card
          opacityValue="unset"
          backgroundColor="#FFE9EC"
          className={infoMsgCard}
        >
          <div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                fill="#C50000"
              />
              <path
                d="M12.525 15.5006L12.9501 6.99875C12.9772 6.45541 12.544 6 12 6C11.456 6 11.0228 6.45542 11.0499 6.99875L11.475 15.5006C11.489 15.7804 11.7199 16 12 16C12.2801 16 12.511 15.7804 12.525 15.5006Z"
                fill="#C50000"
              />
              <circle cx="12" cy="18" r="1" fill="#C50000" />
            </svg>
          </div>
          <p>
            Sorry, we can&apos;t retrieve your personal details via MyInfo.
            Please <Link to={ROUTE_PATH.MLTC_CONTACT_US}>contact us</Link> and
            we&apos;ll help you out.
          </p>
          <div onClick={() => setIsGenericError(false)}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.46967 0.46967C0.762563 0.176777 1.23744 0.176777 1.53033 0.46967L13.5303 12.4697C13.8232 12.7626 13.8232 13.2374 13.5303 13.5303C13.2374 13.8232 12.7626 13.8232 12.4697 13.5303L0.46967 1.53033C0.176777 1.23744 0.176777 0.762563 0.46967 0.46967Z"
                fill="#434343"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.5303 0.46967C13.8232 0.762563 13.8232 1.23744 13.5303 1.53033L1.53033 13.5303C1.23744 13.8232 0.762563 13.8232 0.46967 13.5303C0.176777 13.2374 0.176777 12.7626 0.46967 12.4697L12.4697 0.46967C12.7626 0.176777 13.2374 0.176777 13.5303 0.46967Z"
                fill="#434343"
              />
            </svg>
          </div>
        </Card>
      )}
      <Card width={"788px"} opacityValue="uset">
        <img
          width={"229px"}
          height={"52px"}
          src={sinpassLogo}
          alt={"singpass-logo"}
        />
        <div className={`${cardStyle} ${contentLogin}`}>
          Retrieve Myinfo with Singpass to prefill the application.
        </div>
        <CustomButton
          onClick={() => onClickRetrieveSingpass()}
          background={"#F4333D"}
          type="button"
        >
          <img
            className={PermissionButton}
            src={SingPassPermissionButton}
            alt="singpass permission button"
          />
        </CustomButton>
        <CustomButton
          onClick={goBack}
          className={backButton}
          background="none"
          type="button"
        >
          Back
        </CustomButton>
        <div className={cardStyle}>
          By proceeding, you consent to Singapore Life Ltd.
          (&quot;Singlife&quot;) collecting, processing, disclosing and/or
          transferring your personal data to Singlife related group of
          companies, third party service providers and/or intermediaries
          (including your financial adviser or your most recently appointed
          financial adviser, where applicable and as the case may be) whether
          located in Singapore or elsewhere, to assist you with application. For
          details of Singlife's Data Protection Notice, please refer to{" "}
          <AnchorTag
            target="blank"
            href="https://singlife.com/en/pdpa#contact-us"
          >
            Singlife&apos;s Data Protection Notice
          </AnchorTag>
          . Should you wish to withdraw your consent, you may contact Singlife
          at{" "}
          <AnchorTag href="mailto:cs_life@singlife.com">
            cs_life@singlife.com
          </AnchorTag>{" "}
          or <AnchorTag href="tel:+6568279933">+65 6827 9933.</AnchorTag>
        </div>

        {isShowAddMyInfo && (
          <CustomButton
            onClick={() => toggleAddInfoForm()}
            className={backButton}
            background="none"
          >
            Add Manual Data
          </CustomButton>
        )}
      </Card>
    </>
  );
}

export default SingpassPermission;
